import React from 'react';

const VideoEmbed = ({ embedUrl, title }) => (
    <div className="relative aspect-video overflow-hidden bg-[#f5f3f0]">
        <iframe
            className="h-full w-full border-0"
            src={embedUrl}
            title={title}
            loading="lazy"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
            referrerPolicy="strict-origin-when-cross-origin"
        />
    </div>
);

export default VideoEmbed;
